<template>
  <div class="page">
    <div class="top">
      <van-field
        v-model="price"
        placeholder="输入金额"
        type="number"
        label-class="label-css"
        label="金额（元）"
      />
    </div>
    <div class="bar"></div>
    <div class="container">
      <div class="item">
        <div class="left">
          <img src="./assets/img/weilogo@2x.png" alt="" />
        </div>
        <div class="mid">微信支付</div>
        <div class="right">
          <van-checkbox
            shape="square"
            icon-size="16px"
            checked-color="#2ADA78"
            v-model="vxChecked"
          ></van-checkbox>
        </div>
      </div>
    </div>
    <div class="bar"></div>
    <div class="bot">
      <!-- <div class="btn">充值</div> -->
      <van-button
        @click="recharge()"
        type="primary"
        :disabled="price && vxChecked ? false : true"
        class="btn"
        >充值</van-button
      >
    </div>
  </div>
</template>

<script>
import storejs from "store";
import util from "@/libs/util.js";
import moment from "moment";
import { Dialog, Field, Checkbox, CheckboxGroup, Button, Toast } from "vant";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";
var wx = require("weixin-js-sdk");

export default {
  name: "Mine",
  components: {
    Dialog,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Toast.name]: Toast,
  },
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData"),
      price: "",
      vxChecked: true,
      baseInfo: {},
      unionId: "",
      openId: "",
    };
  },
  watch: {},
  mounted() {
    if (this.$page.isInWechat) {
      wechatService.auth(
        0,
        ({ openid, unionid }) => {
          if (!!openid && !!unionid) {
            console.log("openId", openid);
            this.unionId = unionid;
            this.openId = openid;
          }
        },
        false
      );
    }
  },
  beforeDestroy: function () {},
  methods: {
    // async getAcount() {
    //   // accountLogin/getAccountBasic
    //   let res = await this.$http.post("/api/accountLogin/getAccountBasic", {
    //     companyId: this.publicData.companyId,
    //     accountId: this.publicData.id,
    //   });
    //   if (!res.code) {
    //     console.log("publicData", this.publicData);
    //     this.publicData.accountBasic = res.t;
    //     this.baseInfo = this.publicData.accountBasic;
    //     console.log("res", res);
    //   }
    // },
    async recharge() {
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "支付中...",
      });
      let params = {
        accountId: this.publicData.accountBasic.accountId,
        amount: this.price,
        payType: 1,
        subAccountId: "",
        companyId: "",
        opName: "",
        summary: `给${this.publicData.accountBasic.name}(${this.publicData.accountBasic.phone})充值${this.price}元`,
      };
      if (this.$page.isInMiniprogram) {
        let res = await this.$http.post("/api/accountBill/recharge", params);
        Toast.clear();
        if (res.code == 0) {
          let aliParams = {
            accountBillId: res.t.id,
            paytype: "W06",
            acct: this.openId,
          };
          let aliRes = await this.$http.post("/api/order.union.create",aliParams);

          if (!aliRes.code) {
            let payinfo = JSON.parse(aliRes.t.payinfo);
            console.log("payinfo", payinfo);
            wx.miniProgram.navigateTo({
              url:"/pages/pay/pay?iid=0" +"&payInfo=" +encodeURIComponent(JSON.stringify(payinfo)) +"&from=1",
              success: function () {
                window.history.go(-1);
              },
            });
          }
        } else {
        }
      } else {
        Toast.clear();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .top {
    .label-css {
      font-size: 0.12rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #2dd97a;
    }
  }
  .container {
    padding: 0.22rem 0.16rem;
    .item {
      display: flex;
      align-items: center;
      .left {
        width: 0.15rem;
        height: 0.15rem;
        display: flex;
        img {
          width: 0.15rem;
          height: 0.15rem;
        }
      }
      .mid {
        font-size: 0.12rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #052433;
        margin-left: 0.09rem;
      }
      .right {
        margin-left: auto;
      }
    }
  }
  .bot {
    width: 100%;
    display: flex;
    justify-content: center;
    .btn {
      width: 3.45rem;
      height: 0.5rem;
      background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);
      border-radius: 0.25rem;

      font-size: 0.15rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      margin-top: 0.2rem;
      text-align: center;
      border: 0;
    }
  }
  .bar {
    width: 100%;
    height: 0.08rem;
    background: #f5f8f7;
  }
}
</style>

<style lang="scss">
.page {
  .van-field {
    .label-css {
      font-size: 0.12rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #2dd97a;
    }
  }
}
</style>